import { Card, CardHeader, Body1Strong, Body2 } from '@fluentui/react-components';
import { Warning16Regular } from '@fluentui/react-icons';
import React from 'react'
import { useTranslation } from 'react-i18next';

const WarningCard : React.FC<any> = ({styles}) => {
  const { t } = useTranslation();

  return (
    <Card className={styles.warningCard}>
        <CardHeader
            header={
                <div className={styles.cardHeader}>
                    <Warning16Regular className={styles.warningIcon} />
                    <Body1Strong>
                        {t('info.warning.title', 'Important Security & Billing Notice')}
                    </Body1Strong>
                </div>
            }
        />
        <Body2>
            <ul className={styles.warningList}>
                <li>
                    {t('info.warning.billing', 'API usage incurs charges based on the service provider\'s pricing. Monitor your usage to avoid unexpected costs.')}
                </li>
                <li>
                    {t('info.warning.security', 'Never share your API keys. Treat them like passwords. Keys stored in this add-in are kept locally in your Excel.')}
                </li>
                <li>
                    {t('info.warning.rateLimits', 'Services have rate limits. Excessive usage may be throttled or incur additional charges.')}
                </li>
                <li>
                    {t('info.warning.data', 'Data sent to AI services may be used for training. Check your provider\'s data usage policy.')}
                </li>
            </ul>
        </Body2>
    </Card>
  )
}

export default WarningCard;
